import { jsxs, jsx } from 'react/jsx-runtime';
import { useContext, useMemo, useCallback } from 'react';
import { useCheckoutContext } from '@zooplus/checkout-state';
import { ADDRESS_PROJECT_ID, CUSTOMER_TYPE } from '../constant/constants.js';
import { AddressActionsContext } from '../context/address-context.js';
import { convertPUDOAddressToReadonlyAddress } from '../utils/index.js';
import { AddressType } from '../../address/types/address-form-types.js';
import { AddressCard } from './address-card/address-card.js';
import styles from './readonly-address.module.scss.js';

const ReadonlyAddress = () => {
    const { showSavedAddresses, editDeliveryAddress, editInvoiceAddress = () => { }, } = useContext(AddressActionsContext);
    const { customerAddressesState = {} } = useCheckoutContext(ADDRESS_PROJECT_ID);
    const { deliveryAddress = {}, invoiceAddress = {}, invoiceSameAsDelivery, pudoInfo, customerType = '', isLastContainerActive, setIsDeliveryAndInvoiceCollapsed, setIsEditStepTriggered, } = customerAddressesState;
    const convertedDeliveryAddress = useMemo(() => {
        if (!pudoInfo) {
            return deliveryAddress;
        }
        return convertPUDOAddressToReadonlyAddress(pudoInfo);
    }, [deliveryAddress, pudoInfo]);
    const callCheckoutHooks = useCallback(() => {
        if (!isLastContainerActive)
            setIsEditStepTriggered?.(true);
        setIsDeliveryAndInvoiceCollapsed?.(false);
    }, [isLastContainerActive, setIsDeliveryAndInvoiceCollapsed, setIsEditStepTriggered]);
    const handleEditDeliveryAddress = useCallback(() => {
        const isNewOrExistingCustomer = [
            CUSTOMER_TYPE.EXISTING_CUSTOMER,
            CUSTOMER_TYPE.NEW_CUSTOMER,
        ].includes(customerType);
        callCheckoutHooks();
        if (isNewOrExistingCustomer) {
            showSavedAddresses();
        }
        else {
            editDeliveryAddress(deliveryAddress, false);
        }
    }, [callCheckoutHooks, customerType, deliveryAddress, editDeliveryAddress, showSavedAddresses]);
    const handleEditInvoiceAddress = useCallback(() => {
        callCheckoutHooks();
        editInvoiceAddress(invoiceAddress);
    }, [callCheckoutHooks, editInvoiceAddress, invoiceAddress]);
    return (jsxs("div", { "data-testid": "readonlyAddress", className: styles.readonlyAddressContainer, children: [jsx(AddressCard, { type: pudoInfo ? AddressType.PUDO : AddressType.DELIVERY, onEdit: handleEditDeliveryAddress, address: convertedDeliveryAddress }), jsx(AddressCard, { type: AddressType.INVOICE, onEdit: handleEditInvoiceAddress, address: invoiceAddress, invoiceSameAsDelivery: invoiceSameAsDelivery })] }));
};

export { ReadonlyAddress as default };
//# sourceMappingURL=readonly-address.js.map
